import * as base from './base.jsx';

class BaseBlock extends base.BaseComponent {
  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      blockClass: this.props.blockClass
    });
  }

  /* These are functions you might want to override */

  /* this is the class used on the outer div */
  getBlockClass() {
    if (this.state.blockClass) {
      return "base-block " + this.state.blockClass
    } else {
      return "base-block"
    }
  }

  /* this is the inner bit of the div */
  getContent() {
    return
  }

  /* end of commonly overriden methods */

  render() {
    return <div className="fullscreen-block-wrap">
      <div className={ this.getBlockClass() }>
      { this.getContent() }
      </div>
    </div>
  }
}

class FilterBlock extends base.BaseComponent {
  constructor(props) {
    super(props);

    this.state.filterCount = this.countChildFilters(this.props.children);
    this.state.filters = {};
    this.state.finished = false;
  }

  countChildFilters(children) {
    var count = 0;
    React.Children.map(children, (child) => {
      if (child && child.props.filterKey) {
        count += 1;
      } else if (child) {
        count += this.countChildFilters(child.props.children);
      }
    });

    return count;
  }

  componentWillMount() {
    radio("filterInitialized").subscribe(this.filterInitialized.bind(this));
  }

  filterInitialized(filter) {
    this.setState(currentState => {
      currentState.filters[filter.props.filterKey] = filter.serializeFilter(filter.state);

      if (Object.keys(currentState.filters).length == currentState.filterCount
        && !currentState.finished) {
        setTimeout(() => {
          radio("filtersFinishedInitialized").broadcast(currentState.filters);
        }, 0);
        currentState.finished = true;
      }

      return currentState;
    })
  }

  mobileClicked() {
    this.setState({
      "showMobileFilters": !this.state.showMobileFilters
    });
  }

  render() {
    var mobileFiltersClass = "filters mobile";
    if (this.state.showMobileFilters) {
      mobileFiltersClass += " shown";
    }

    return <div className="outer-filter-container">
      <div className="filters">
        <span className="filters-container">
          { this.props.children }
        </span>
      </div>
      <div className={ mobileFiltersClass }>
        <div className="filter-header" onClick={this.mobileClicked.bind(this)}>
          <i className="icon-filter-1"></i> Filters
          <i className="icon-arrow-65 dropdown-arrow"></i>
        </div>
        <div className="filters-container">
          { this.props.children }
        </div>
      </div>
    </div>
  }
}

class SplitBlock extends BaseBlock {
  constructor(props) {
    super(props);
  }

  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      "showingSplit": false
    });
  }

  closeSplitView() {
    this.setState({
      showingSplit: false
    });

    this.splitViewClosed();
  }

  componentWillMount() {
    window.addEventListener("mousedown", this.pageClick.bind(this), false);
  }

  pageClick() {
    if (this.mouseIsDown) {
      return;
    }

    this.closeSplitView();
  }

  mouseDownHandler() {
    this.mouseIsDown = true;
  }

  mouseUpHandler() {
    this.mouseIsDown = false;
  }

  /* These are functions you might want to override */

  /* this is the class used on the outer div */
  getBlockClass() {
    return super.getBlockClass() + " block-split"
  }

  /* put the split content in here */
  getSplitContent() {
    return
  }

  splitViewClosed() {
  }

  /* end of commonly overriden methods */

  getSplitClassName() {
    var className = "split-content";
    if (!this.state.showingSplit) {
      className += " gone";
    }

    if (this.props.forcePortalWidth) {
      className += " portal-width";
    }

    return className;
  }

  getSplitHeaderContent() {
    return <div className="split-header">
      <waffle.misc.CloseButton onClick={this.closeSplitView.bind(this)}/>
      <div className="split-title">
        { this.getSplitTitle() }
      </div>
    </div>
  }

  getSplitTitle() {
    return
  }

  getDismissContainerClass() {
    var className = "dismiss-view";
    if (!this.state.showingSplit) {
      className += " gone";
    }

    return className;
  }

  render() {
    return <div className="fullscreen-block-wrap">
      <div className={ this.getBlockClass() }>
        <div className="split-left">
        { this.getContent() }
        </div>
      </div>
      <div
        className={ this.getSplitClassName() }
        onMouseDown={this.mouseDownHandler.bind(this)}
        onMouseUp={this.mouseUpHandler.bind(this)}
      >
        <div className="actual-content">
          { this.getSplitHeaderContent() }
          { this.getSplitContent() }
        </div>
      </div>
    </div>
  }
}

module.exports = {
  BaseBlock: BaseBlock,
  FilterBlock: FilterBlock,
  SplitBlock: SplitBlock
}
